import React from "react";
import "./Lifestyle.scss";
import ReactPlayer from "react-player";
// const customThumbnails = {
//   buzzReel,
// };

function Lifestyle() {
  return (
    <div className="commercialContainer">
      <div className="comSection mb-20">
        <p className="cTitle">INTERSECTIONAL ENVIRONMENTALIST - CINEMATOGRAPHY & EDITING</p>
        <div className="cVideos">
          <div className="player-wrapperC">
            <ReactPlayer
              width="100%"
              height="100%"
              controls={true}
              className="react-playerC"
              url={"https://www.youtube.com/watch?v=0hW3ZChWiPA&t=51s"}
            />
          </div>
          <div className="player-wrapperC">
            <ReactPlayer
              width="100%"
              height="100%"
              controls={true}
              className="react-playerC"
              url={"https://www.youtube.com/watch?v=N-Uaf5k-cu4"}
            />
          </div>
        </div>
      </div>
      <div className="comSection" style={{ marginBottom: "5rem" }}>
        <p className="cTitle">DIANDRA MARIZET - CINEMATOGRAPHY & EDITING</p>
        <div className="cVideos">
          <Video
            poster="https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/DIANDRA%20MARIZET%20(INTERSECTIONAL%20ENVIRONMENTALIST)%20-%20VIDEOGRAPHY%2F1.%20Finding%20Medicine.png?alt=media"
            className="cVid"
            src="https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/DIANDRA%20MARIZET%20(INTERSECTIONAL%20ENVIRONMENTALIST)%20-%20VIDEOGRAPHY%2F1.%20DM_ELIX_FindingMedicineInNature(COMPRESSED).mp4?alt=media"
          />
          <Video
            className="cVid"
            poster="https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/DIANDRA%20MARIZET%20(INTERSECTIONAL%20ENVIRONMENTALIST)%20-%20VIDEOGRAPHY%2F2.%20Book%20Reel.jpg?alt=media"
            src="https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/DIANDRA%20MARIZET%20(INTERSECTIONAL%20ENVIRONMENTALIST)%20-%20VIDEOGRAPHY%2FDIANDRA%20MARIZET%202.%20Book%20Reel%20(COMPRESSED).mp4?alt=media"
          />
          <Video
            className="cVid"
            poster="https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/DIANDRA%20MARIZET%20(INTERSECTIONAL%20ENVIRONMENTALIST)%20-%20VIDEOGRAPHY%2F3.%20Picture%20Apparel.png?alt=media"
            src="https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/DIANDRA%20MARIZET%20(INTERSECTIONAL%20ENVIRONMENTALIST)%20-%20VIDEOGRAPHY%2F3.%20Picture%20Apparel%20(COMPRESSED).mp4?alt=media"
          />
        </div>

        <div className="player-wrapperL">
          <ReactPlayer
            width="100%"
            height="100%"
            controls={true}
            className="react-playerL"
            url={"https://www.youtube.com/watch?v=UGVkCt0qJnc&t=21s"}
          />
        </div>
      </div>
    </div>
  );
}

const Video = ({ src, ...props }) => (
  <video controls {...props}>
    <source src={src} type="video/mp4" />
    Your browser does not support the video tag.
  </video>
);

export default Lifestyle;
